/* eslint-disable no-param-reassign */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-plusplus */
/* eslint-disable no-underscore-dangle */
import { fabric } from 'fabric';
import { clamp, uniq } from 'lodash';
import { getIndex } from '../../fabric_obj/container';
import { updateCommonSettings } from '../../redux/board/reducer';
import {
  BACKGROUND_EDGE_NAME,
  BACKGROUND_EDGE_OPTIONS,
  BORDER_LINE_ID,
  BUS_EVENTS,
  CANVAS_DEFAULT_SIZE,
  CIRCLE,
  EDGE_NAME_PREFIX,
  FABRIC_CUSTOM_OBJECT,
  IMAGE,
  IMAGE_ID,
  ITEXT,
  MAXIMUM_PAGESIZE,
  MINIMUM_PAGESIZE,
  OVER_LINE_ID,
  PAGE_OPTION,
  TEXTBOX,
  ZOOM_DEFAULT,
} from '../constants';
import eventBus from '../eventBus';
import { generateId } from './components';

export const cloneObjectWithKey = (obj, keys) => {
  const newO = {};
  Object.keys(obj).forEach((k) => {
    if (keys.includes(k)) {
      newO[k] = obj[k];
    }
  });
  return newO;
};
export const getCurrentViewCanvasSize = () => {
  const canvasViewElement = document.getElementById('canvas-view');
  if (!canvasViewElement) {
    return {
      width: CANVAS_DEFAULT_SIZE.getWidth(),
      height: CANVAS_DEFAULT_SIZE.getHeight(),
    };
  }
  return { width: canvasViewElement.offsetWidth, height: canvasViewElement.offsetHeight };
};
export const updateCanvasSize = (canvas) => {
  if (canvas) {
    setTimeout(() => {
      const { width, height } = getCurrentViewCanvasSize();
      canvas.setWidth(width);
      canvas.setHeight(height);
      canvas.requestRenderAll();
    }, 300);
  }
};
export const resetViewCanvas = () => {
  const { left = 0, top = 0 } = window.canvas?.backgroundImage || {};
  window.canvas?.setViewportTransform([1, 0, 0, 1, -left, -top]);
  eventBus.emit(BUS_EVENTS.UPDATE_ZOOM_SLIDER, ZOOM_DEFAULT);
  eventBus.emit(BUS_EVENTS.UPDATE_POSITION_MENU_EDITOR);
};
export const getCurrentState = () => window.canvas.toDatalessJSON(propertiesToInclude);
export const updateBackgroundImageFromPageSetting = (pageSetting, ct) => {
  const canvas = ct || window.canvas;
  if (!pageSetting) return;
  const currentSetting = { ...pageSetting };
  const { w, h, color = '#ffffff', t = 0, l = 0 } = currentSetting;
  const tmp = PAGE_OPTION.find((e) => (e.value.w === w && e.value.h === h ? e.value.isLocked : false));
  const isLocked = currentSetting.isLocked || tmp;
  let options;
  if (isLocked)
    options = {
      top: t,
      left: l,
      width: w,
      height: h,
      fill: color,
      isNotObj: true,
      settings: currentSetting,
      strokeWidth: 0,
    };
  else {
    let { left, top, bot, right } = getBoundingOfAllObjects(canvas);
    if (!left && !top && !bot && !right) {
      left = currentSetting.l;
      top = currentSetting.t;
      right = left + MINIMUM_PAGESIZE;
      bot = top + MINIMUM_PAGESIZE;
    }
    left = expandDown(left);
    right = expandUp(right);
    top = expandDown(top);
    bot = expandUp(bot);
    options = {
      top,
      left,
      width: clamp(right - left, w, MAXIMUM_PAGESIZE),
      height: clamp(bot - top, h, MAXIMUM_PAGESIZE),
      fill: color,
      isNotObj: true,
      settings: currentSetting,
      strokeWidth: 0,
    };
  }

  if (canvas.backgroundImage?.set) {
    canvas.backgroundImage?.set(options);
  } else {
    const rect = new fabric.Rect(options);
    canvas.setBackgroundImage(rect);
  }
  canvas.backgroundImage?.setCoords();

  if (isLocked) updateEdgePage(canvas);
};
export function renderTextLine(method, ctx, line, left, top, lineIndex) {
  const BULLET_CENTER_EPSILON = 1.5;
  const firstCharStyle = this.getCompleteStyleDeclaration(lineIndex, 0);
  let bullet;
  if (this.listType === 'unorderList') {
    bullet = ['•'];
  } else {
    bullet = [`${this.listCounter + 1}.`];
  }
  let bulletLeftOffset;
  if (this.listType === 'unorderList') {
    const bulletCenterOffset = firstCharStyle.fontSize / BULLET_CENTER_EPSILON;
    bulletLeftOffset = left - bulletCenterOffset;
  } else {
    const bulletOffset = firstCharStyle.fontSize;
    bulletLeftOffset = left - bulletOffset;
  }
  if (line.length) {
    if (!this.isWrapping && this.simulateList) {
      this._renderChars(method, ctx, bullet, bulletLeftOffset, top, lineIndex);
      this.isWrapping = !this.isEndOfWrapping(lineIndex);
      if (!this.isWrapping) this.listCounter++;
    } else if (this.isEndOfWrapping(lineIndex)) {
      this.isWrapping = false;
      this.listCounter++;
    }
  }
  if (lineIndex === this.textLines.length - 1) {
    this.isWrapping = false;
    this.listCounter = 0;
  }
  this._renderChars(method, ctx, line, left, top, lineIndex);
}

export function getLineLeftOffset(lineIndex) {
  const CENTER_EPSILON = 0.1;
  const lineWidth = this.getLineWidth(lineIndex);
  const lineDiff = this.width - lineWidth;
  const textAlign = this.textAlign;
  let leftOffset = 0;
  switch (textAlign) {
    case 'left':
      leftOffset = this.simulateList ? this.fontSize : leftOffset;
      break;
    case 'center':
      leftOffset = this.simulateList ? lineDiff / 2 + this.fontSize * CENTER_EPSILON : lineDiff / 2;
      break;
    case 'right':
      leftOffset = this.simulateList ? lineDiff - this.fontSize * CENTER_EPSILON : lineDiff;
      break;
    default:
      break;
  }
  return leftOffset;
}

export const reRenderTextTypeList = (c) => {
  fabric.Textbox.prototype.set({
    _getLineLeftOffset: getLineLeftOffset,
    _renderTextLine: renderTextLine,
    dirty: true,
  });
  c.renderAll();
};

export const propertiesToInclude = [
  'id',
  'imageId',
  'name',
  'subType',
  'colorSetting',
  'parentId',
  'listType',
  'listBullet',
  'listCounter',
  'simulateList',
  'objectCaching',
  'selectable',
  'hasBorders',
  'hasControls',
  'evented',
  'isDiagram',
  'isContainer',
  'isNotObj',
  'originalName',
  'fromPort',
  'fromId',
  'toPort',
  'toId',
  'perPixelTargetFind',
  'origin',
  'destination',
  'relativePosition',
  'polylineId',
  'points',
  'arrowHeadType',
  'arrowTailType',
  'lineShape',
  'shapeBorderRadius',
  'bodyControls',
  'distanceFromOrigin',
  'distanceFromDestination',
  'isMiddle',
  'isFirst',
  'isLast',
  'firstIndex',
  'secondIndex',
  'htmlContent',
  'lockMovementX',
  'lockMovementY',
  'src',
  'padding',
  'moveCursor',
  'settings',
  'hoverCursor',
  '_renderTextLine',
  '_getLineLeftOffset',
  'isOverContainer',
  'isLabelComponent',
  'isUMLComponent',
  'isCustomText',
  'isTextComponent',
  'isIconComponent',
  'isPathComponent',
  'maxWidth',
  'hasShapeSuggest',
];
export const isEdgeOfPage = (object) => !!object?.name?.includes(EDGE_NAME_PREFIX);
export const getBoundingOfAllObjects = (canvas) => {
  let [left, top, bot, right] = [
    Number.MAX_SAFE_INTEGER,
    Number.MAX_SAFE_INTEGER,
    Number.MIN_SAFE_INTEGER,
    Number.MIN_SAFE_INTEGER,
  ];
  let objects = canvas.getObjects();
  if (!objects.length)
    return {
      left: 0,
      top: 0,
      bot: 0,
      right: 0,
    };

  const activeObject = canvas.getActiveObject();
  if (activeObject?.type === 'activeSelection' && !!activeObject?.getObjects()?.length) {
    objects = objects.filter((obj) => !activeObject?.getObjects()?.find((o) => o.id === obj.id));
    objects.push(activeObject);
  }
  objects.forEach((object) => {
    const { left: l, top: t, width: w, height: h } = object.getBoundingRect(true);
    left = Math.min(left, l);
    top = Math.min(top, t);
    right = Math.max(right, l + w);
    bot = Math.max(bot, t + h);
  });
  return {
    left,
    top,
    bot,
    right,
  };
};
export const expandUp = (number, base = MINIMUM_PAGESIZE, eps = 10) => {
  const r = ((number % base) + base) % base;
  if (r === 0) return number;
  const delta = r >= eps ? base - r : -r;
  return number + delta;
};

export const expandDown = (number, base = MINIMUM_PAGESIZE, eps = 10) => {
  const r = ((number % base) + base) % base;
  if (r === 0) return number;
  const delta = r + eps <= base ? -r : base - r;
  return number + delta;
};
export const updateEdgePage = (currentCanvas) => {
  const canvas = currentCanvas || window.canvas;
  const [botEdge, leftEdge, rightEdge, topEdge] = getEdgeOfBackgroundCanvas(canvas);
  const { left, top, width, height } = canvas.backgroundImage;
  const bottom = top + height;
  const right = left + width;
  leftEdge.set({
    x1: left,
    y1: top,
    x2: left,
    y2: bottom,
  });
  rightEdge.set({
    x1: right,
    y1: top,
    x2: right,
    y2: bottom,
  });
  topEdge.set({
    x1: left,
    y1: top,
    x2: right,
    y2: top,
  });
  botEdge.set({
    x1: left,
    y1: bottom,
    x2: right,
    y2: bottom,
  });
  leftEdge.setCoords();
  rightEdge.setCoords();
  topEdge.setCoords();
  botEdge.setCoords();
};
export const getEdgeOfBackgroundCanvas = (currentCanvas) => {
  const canvas = currentCanvas || window.canvas;
  if (!canvas) return;
  let listEdge = Object.keys(BACKGROUND_EDGE_NAME).map((key) => {
    const name = BACKGROUND_EDGE_NAME[key];
    let line = canvas.getObjects('line').find((obj) => obj.name === name);
    const lockMovementX = [BACKGROUND_EDGE_NAME.top, BACKGROUND_EDGE_NAME.bottom].includes(name);
    const lockMovementY = [BACKGROUND_EDGE_NAME.left, BACKGROUND_EDGE_NAME.right].includes(name);
    const hoverCursor = lockMovementX ? 'row-resize' : 'col-resize';
    const moveCursor = hoverCursor;
    if (!line) {
      line = new fabric.Line([0, 0, 0, 0]);
      canvas.add(line);
    }
    line.set({
      ...BACKGROUND_EDGE_OPTIONS,
      id: `${name}-${generateId()}`,
      name,
      lockMovementX,
      lockMovementY,
      hoverCursor,
      moveCursor,
    });
    return line;
  });
  listEdge.sort((a, b) => (a.name > b.name ? 1 : -1));
  //// return [bot,left,right,top]
  return listEdge;
};
export const getSettingsUpdateFromBackgroundImage = (canvas = window.canvas) => {
  const { top, left, width, height, fill } = canvas.backgroundImage;
  return {
    t: top,
    l: left,
    w: width,
    h: height,
    color: fill,
  };
};
export const prepareCanvasBorders = (canvas) => {
  canvas.line1 = makeLine([0, 0, 0, 0], {
    id: BORDER_LINE_ID,
    position: 'top',
    stroke: '#CFD9F7',
    strokeWidth: 3,
    isNotObj: true,
  });
  canvas.line2 = makeLine([0, 0, 0, 0], {
    id: BORDER_LINE_ID,
    position: 'right',
    stroke: '#CFD9F7',
    strokeWidth: 3,
    isNotObj: true,
  });
  canvas.line3 = makeLine([0, 0, 0, 0], {
    id: BORDER_LINE_ID,
    position: 'bottom',
    stroke: '#CFD9F7',
    strokeWidth: 3,
    isNotObj: true,
  });
  canvas.line4 = makeLine([0, 0, 0, 0], {
    id: BORDER_LINE_ID,
    position: 'left',
    stroke: '#CFD9F7',
    strokeWidth: 3,
    isNotObj: true,
  });
  canvas.oLine1 = makeLine([0, 0, 0, 0], {
    id: OVER_LINE_ID,
    position: 'top',
    stroke: '#096dd9',
    strokeWidth: 2,
  });
  canvas.oLine2 = makeLine([0, 0, 0, 0], {
    id: OVER_LINE_ID,
    position: 'right',
    stroke: '#096dd9',
    strokeWidth: 2,
  });
  canvas.oLine3 = makeLine([0, 0, 0, 0], {
    id: OVER_LINE_ID,
    position: 'bottom',
    stroke: '#096dd9',
    strokeWidth: 2,
  });
  canvas.oLine4 = makeLine([0, 0, 0, 0], {
    id: OVER_LINE_ID,
    position: 'left',
    stroke: '#096dd9',
    strokeWidth: 2,
  });
};
export const makeLine = (coords, attr) =>
  new fabric.Line(coords, {
    fill: '#CFD9F7',
    strokeWidth: 3,
    selectable: false,
    hasBorders: false,
    evented: false,
    ...attr,
  });
export const textAlignInGroup = (canvas, editObj, pos, dispatch) => {
  const eps = 5;
  const items = editObj.getObjects();
  const text = getObjectByType(items, [TEXTBOX, ITEXT]);
  const obj = items.find((o) => ![TEXTBOX, ITEXT].includes(o.type)).set({ height: editObj.height });
  obj.setCoords();
  const { tl, tr, bl, br } = obj._getCoords(true);
  const pointCenter = obj.getCenterPoint();
  if (['left', 'right', 'center'].includes(pos)) {
    text.set({ textAlign: pos });
  } else {
    switch (pos) {
      case 'top':
        text.set({
          originY: 'top',
          originX: 'center',
          top: (tl.y + tr.y) / 2 + eps,
          left: (tl.x + tr.x) / 2,
        });
        break;
      case 'middle':
        text.set({
          originX: 'center',
          originY: 'center',
          top: pointCenter.y,
          left: pointCenter.x,
        });
        break;
      case 'bottom':
        text.set({
          originY: 'bottom',
          originX: 'center',
          top: (bl.y + br.y) / 2 - eps,
          left: (bl.x + br.x) / 2,
        });
        break;
      default:
        break;
    }
  }
  text.setCoords();
  canvas.renderAll();
  const coords = {
    x: text.left || 0,
    y: text.top || 0,
    width: text.width || 0,
    height: text.height || 0,
    angle: text.angle || 0,
    scaleX: text.scaleX || 1,
    scaleY: text.scaleY || 1,
  };
  dispatch(updateCommonSettings(coords));
};

export const drawBorderOnOver = (canvas, obj) => {
  const { drawOnOver } = canvas;
  const lines = canvas.getObjects().filter((o) => o.type === 'line' && o.id === OVER_LINE_ID);
  if (obj && obj.isContainer) {
    canvas.oLine1.set({ stroke: '#ec1c24' });
    canvas.oLine2.set({ stroke: '#ec1c24' });
    canvas.oLine3.set({ stroke: '#ec1c24' });
    canvas.oLine4.set({ stroke: '#ec1c24' });
  } else {
    canvas.oLine1.set({ stroke: '#096dd9' });
    canvas.oLine2.set({ stroke: '#096dd9' });
    canvas.oLine3.set({ stroke: '#096dd9' });
    canvas.oLine4.set({ stroke: '#096dd9' });
  }

  if (!drawOnOver) {
    canvas.remove(...lines);
  } else {
    const { tl, tr, bl, br } = obj.aCoords;
    const offset = 2;
    canvas.oLine1.set({
      x1: tl.x - offset,
      y1: tl.y - offset,
      x2: tr.x + offset,
      y2: tr.y - offset,
    });
    canvas.oLine2.set({
      x1: tr.x,
      y1: tr.y - offset,
      x2: br.x,
      y2: br.y + offset,
    });
    canvas.oLine3.set({
      x1: bl.x - offset,
      y1: bl.y,
      x2: br.x + offset,
      y2: br.y,
    });
    canvas.oLine4.set({
      x1: bl.x - offset,
      y1: bl.y + offset,
      x2: tl.x - offset,
      y2: tl.y - offset,
    });
    canvas.add(canvas.oLine1, canvas.oLine2, canvas.oLine3, canvas.oLine4);
  }
};
export const getViewportTransform = () => {
  const [scaleX, skewX, skewY, scaleY, translationX, translationY] = window.canvas.viewportTransform;
  return {
    scaleX,
    skewX,
    skewY,
    scaleY,
    translationX,
    translationY,
  };
};
export const createImageFromUrl = (url, options, callback) => {
  fabric.Image.fromURL(
    url,
    (obj) => {
      callback(obj);
    },
    {
      ...options,
      name: IMAGE,
      id: `${generateId()}_${IMAGE_ID}`,
      crossOrigin: 'Anonymous',
    },
  );
};
export const ungroup = (group, canvas, selectable = false) => {
  const items = group.getObjects();
  // group._restoreObjectsState(); // keep it for text selection
  items.forEach((item) => {
    item.set({
      selectable,
      dirty: true,
    });
    canvas.insertAt(item, getIndex(group));
  });
  group.destroy();
  canvas.remove(group);
  canvas.renderAll();
  return items;
};
export const getLongestLineWidth = () => {
  const activeObject = window.canvas.getActiveObject();
  const cln = { ...JSON.parse(JSON.stringify(activeObject)) };
  delete cln.width;
  const { textWidth } = getTextSize(activeObject.text, cln);
  return textWidth;
};
export const handleMovingEdgeOfBackgroundCanvas = (object, pointer) => {
  const canvas = window.canvas;
  object.setCoords();
  let { x, y } = pointer;
  const { left, top, width, height } = canvas.backgroundImage;
  const bottom = top + height;
  const right = left + width;
  switch (object.name) {
    case BACKGROUND_EDGE_NAME.top:
      y = Math.min(y, bottom);
      canvas.backgroundImage.set({
        top: y,
        height: bottom - y,
      });
      break;
    case BACKGROUND_EDGE_NAME.bottom:
      y = Math.max(y, top);
      canvas.backgroundImage.set({
        height: Math.max(0, y - top),
      });
      canvas.backgroundImage.setCoords();
      break;
    case BACKGROUND_EDGE_NAME.left:
      x = Math.min(x, right);
      canvas.backgroundImage.set({
        left: x,
        width: right - x,
      });
      break;
    case BACKGROUND_EDGE_NAME.right:
      x = Math.max(x, left);
      canvas.backgroundImage.set({
        width: x - left,
      });
      break;

    default:
      break;
  }
};
export const getObjCoords = (arr) => {
  const a = arr.map((o) => {
    delete o.mtr;
    return o;
  });
  const xs = [];
  const ys = [];
  a.forEach((o) => {
    Object.values(o).forEach((i) => {
      xs.push(i.x);
      ys.push(i.y);
    });
  });
  const coords = {
    tl: {
      x: Math.min(...xs),
      y: Math.min(...ys),
    },
    tr: {
      x: Math.max(...xs),
      y: Math.min(...ys),
    },
    bl: {
      x: Math.min(...xs),
      y: Math.max(...ys),
    },
    br: {
      x: Math.max(...xs),
      y: Math.max(...ys),
    },
  };
  return coords;
};
export const drawEditBorder = (coords, canvas) => {
  const { tl, tr, bl, br } = coords;
  const lines = canvas.getObjects().filter((o) => o.type === 'line' && o.id === BORDER_LINE_ID);
  const top = lines.find((l) => l.position === 'top');
  const right = lines.find((l) => l.position === 'right');
  const bottom = lines.find((l) => l.position === 'bottom');
  const left = lines.find((l) => l.position === 'left');
  top.set({
    x1: tl.x,
    y1: tl.y,
    x2: tr.x,
    y2: tr.y,
  });
  right.set({
    x1: tr.x,
    y1: tr.y,
    x2: br.x,
    y2: br.y + 2,
  });
  bottom.set({
    x1: br.x + 2,
    y1: br.y,
    x2: bl.x,
    y2: bl.y,
  });
  left.set({
    x1: bl.x,
    y1: bl.y,
    x2: tl.x,
    y2: tl.y,
  });
};
export const checkPointerInside = (pointer, coords) => {
  const { x, y } = pointer;
  const b = Object.values(coords);
  const minx = Math.min(...b.map((v) => v.x));
  const maxx = Math.max(...b.map((v) => v.x));
  const miny = Math.min(...b.map((v) => v.y));
  const maxy = Math.max(...b.map((v) => v.y));
  return x >= minx && x <= maxx && y >= miny && y <= maxy;
};
export const getSignedUrlForCanvas = async (content) => {
  try {
    const imageIds = getAllImageIdFromCanvas(content);
    if (!imageIds?.length) return content;
    // const respone = await categoryAPIs.checkAndgetSignedUrlImages({ listId: imageIds });
    // const { data } = respone;
    updateSrcForAllImage(content, imageIds);
  } catch (error) {
    //
  }
  return content;
};
export const htmlImagePropertiesToInclude = [
  'id',
  'angle',
  'crossOrigin',
  'dirty',
  'evented',
  'flipX',
  'flipY',
  'htmlContent',
  'id',
  'name',
  'opacity',
  'originX',
  'originY',
  'scaleX',
  'scaleY',
  'top',
  'left',
  'width',
  'height',
  'isOverContainer',
];
export const getObjectByType = (array = [], type = []) => array.find((o) => type.includes(o.type));
export const getAllImageIdFromCanvas = (canvasContent) => {
  const listId = [];
  getAllImageFromData(canvasContent.objects, (obj) => {
    listId.push(obj.imageId);
  });
  return uniq(listId);
};
export const getAllImageFromData = (data, callback) => {
  if (Array.isArray(data)) data.forEach((obj) => getAllImageFromData(obj, callback));
  else if (data.type === IMAGE && data.imageId) callback(data);
  else if (data.type === 'group' && data?.objects?.length > 0) getAllImageFromData(data.objects, callback);
};
export const updateSrcForAllImage = (canvasContent, dataUpdate) => {
  getAllImageFromData(canvasContent.objects, (obj) => {
    const data = dataUpdate.find((item) => item.id === obj.imageId);
    if (data?.url) obj.src = data.url;
  });
};

export const getTextSize = (text, options) => {
  const newText = new fabric.IText(text, options);
  return { textWidth: newText.width, textHeight: newText.height };
};

export const isValidDate = (d) => {
  return d instanceof Date && !isNaN(d);
};

export const drawBoundingBox = (obj, dispatch, stackOrder) => {
  const { canvas } = window;
  const items = obj.getObjects();

  const diagram = items.find((o) => ![TEXTBOX, ITEXT].includes(o.type));
  const text = items.find((o) => [TEXTBOX, ITEXT].includes(o.type));

  diagram.set({ angle: 0, scaleX: 1, scaleY: 1, height: obj.height * obj.scaleY, width: obj.width * obj.scaleX });
  if (diagram.type === CIRCLE) diagram.set({ radius: diagram.height / 2 });
  text.set({ angle: 0, left: diagram.getCenterPoint().x, top: diagram.getCenterPoint().y });

  const cloneProperties = [
    'id',
    'name',
    'objectCaching',
    'colorSetting',
    'isDiagram',
    'isOverContainer',
    'parentId',
    'type',
    'subType',
    'top',
    'left',
    'angle',
  ];
  const properties = cloneObjectWithKey(obj.toObject(propertiesToInclude), cloneProperties);
  const grp = new fabric.Group(items, properties);
  grp.set({ width: diagram.width * diagram.scaleX, height: diagram.height * diagram.scaleY });
  grp.setCoords();

  diagram.set({ top: (-obj.height * obj.scaleY) / 2 });

  if (text.textAlign !== 'center') {
    textAlignInGroup(canvas, grp, text.textAlign, dispatch);
  }

  let pos = text.originY === 'center' ? 'middle' : text.originY;
  textAlignInGroup(canvas, grp, pos, dispatch);

  canvas.remove(...items, obj);
  canvas.insertAt(grp, stackOrder);
  canvas.setActiveObject(grp);
};

export const getPathValue = (obj) => {
  const div = document.createElement('div');
  div.innerHTML = obj.toSVG();
  const pathElement = div.querySelector('path');
  const pathValue = pathElement.getAttribute('d');
  return pathValue;
};

export const setPathDimensions = (pathString = '', newWidth, newHeight, maxWidth, maxHeight) => {
  const coordinates = pathString.match(/(-?\d+(\.\d+)?)/g).map(Number);

  const originalWidth = Math.max(...coordinates.filter((_, index) => index % 2 === 0));
  const originalHeight = Math.max(...coordinates.filter((_, index) => index % 2 !== 0));

  const widthScaleFactor = (maxWidth || newWidth) / originalWidth;
  const heightScaleFactor = (maxHeight || newHeight) / originalHeight;

  const updatedCoordinates = coordinates.map((coordinate, index) =>
    index % 2 === 0 ? coordinate * widthScaleFactor : coordinate * heightScaleFactor,
  );

  let updatedPathString = '';
  let coordinateIndex = 0;

  for (const command of pathString.match(/[A-Za-z]+/g)) {
    updatedPathString += command;

    let coordinateCount;
    switch (command.toLowerCase()) {
      case 'z':
        coordinateCount = 0;
        break;
      case 'v':
      case 'h':
        coordinateCount = 1;
        break;
      case 'q':
      case 's':
        coordinateCount = 4;
        break;
      case 'c':
        coordinateCount = 6;
        break;
      default:
        coordinateCount = 2;
    }

    for (let i = 0; i < coordinateCount; i++) {
      updatedPathString += ' ' + updatedCoordinates[coordinateIndex];
      coordinateIndex++;
    }
  }

  return updatedPathString;
};

export const getLineOfControlPoint = (point) => {
  let result = null;
  window.canvas.getObjects().find((o) => {
    if (
      (o?.name === FABRIC_CUSTOM_OBJECT.arrowLine ||
        o?.name === FABRIC_CUSTOM_OBJECT.line ||
        o?.name === FABRIC_CUSTOM_OBJECT.verticalLine ||
        o?.name === FABRIC_CUSTOM_OBJECT.horizontalLine) &&
      o.id === point?.diagramConnector?.id
    )
      result = o;
  });
  return result;
};
